import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AlertItem, AlertType } from 'src/app/core/models/AlertItem';
import { AlertService, AuthenticationService, StorageKey, StorageService, ViolationService } from 'src/app/core/services';
import { Gb } from 'src/app/core/services/growthbook.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
  public gb: Gb;
  loginForm: FormGroup;
  loading = false;
  loginInvalid = false;
  token = null;
  private updateProperty: Subject<string> = new Subject<string>();

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private alertService: AlertService,
    private router: Router,
    private storageService: StorageService,
    private violationService: ViolationService
  ) {
    this.updateProperty.pipe(
      debounceTime(500))
      .subscribe(() => {
        this.loginForm.get('recaptcha').setValue(this.token);
      });
    this.gb = new Gb();
  }

  async ngOnInit() {
    this.createForm();
    if (this.storageService.get(StorageKey.currentUser) != null) {
      this.router.navigate(['']);
    }
    await this.gb.init();
    this.token = !this.gb.isOn('ECS-4580') ? 'enabled' : '';
    this.loginForm.get('recaptcha').setValue(this.token);
  }

  disableError() {
    this.loginInvalid = false;
  }

  createForm(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      rememberMe: [false, [Validators.required]],
      recaptcha: [this.token, [Validators.required]]
    });
  }

  login() {
    this.loading = true;
    const email = this.loginForm.get('email').value;
    const password = this.loginForm.get('password').value;
    const rememberMe = this.loginForm.get('rememberMe').value;

    this.authService.login(email, password, rememberMe)
      .then(() => {
        this.loading = false;
        const user = this.storageService.get(StorageKey.currentUser);
        if (!user.adminManagerUser && !user.adminUser) {
          this.violationService.unlock(user.id, []);
        }
        this.router.navigate(['/']);
      }).catch(error => {
        this.loading = false;
        this.loginInvalid = true;
        if (error.status === 403 || error.status === 404) {
          this.alertService.show(new AlertItem('AccessDenied', AlertType.danger));
        } else {
          this.alertService.show(new AlertItem('AccessDenied', AlertType.danger));
        }
      });
  }

  getCaptcha(text: string) {
    this.updateProperty.next(text);
  }
}
